(ns practitest.frontend.components.pagination
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.icons :as icons]))

(defn get-total-pages [total-count per-page]
  (let [total-pages (int (/ total-count per-page))]
    (if (< (* total-pages per-page) total-count)
      (inc total-pages)
      total-pages)))

;; Calculate buttons layout
(defn build-pagination-buttons [total-count per-page max-buttons current-page]
  (let [total-pages (get-total-pages total-count per-page)
        min-first-part-buttons 2
        min-last-part-buttons 2
        middle-part-buttons (int (/ (- max-buttons
                                       min-first-part-buttons
                                       min-last-part-buttons 2)
                                    2))]
    ;; TODO: sanity check for max-buttons ?

    (cond
      ;; Special case - no pagination required
      (<= total-pages 1)
      nil

      ;; We have enough room to fit all buttons
      (<= total-pages max-buttons)
      (-> [:prev]
          (into
            (for [n (range 1 (inc total-pages))]
              n))
          (conj :next))

      :else
      (let [max-first-part (- max-buttons min-last-part-buttons 2)
            min-last-part (+ (- total-pages max-buttons)
                             min-first-part-buttons 3)

            ;; Three cases
            ; 1. Current-page is in the first-part
            ; 2. Current-page is in the middle-part
            ; 3. Current page is in the last part
            current-page-loc (cond
                               (<= current-page max-first-part)
                               :first-part

                               (>= current-page min-last-part)
                               :last-part

                               :else
                               :middle-part)

            first-part-end (case current-page-loc
                             :first-part
                             (- max-buttons min-last-part-buttons 1)

                             (:last-part :middle-part)
                             min-first-part-buttons)
            first-part (range 1 (inc first-part-end))

            middle-part (if (= :middle-part current-page-loc)
                          (apply conj [:ellipsis]
                                 (range (- current-page middle-part-buttons)
                                        (inc (+ current-page middle-part-buttons))))
                          [])

            last-part-start (case current-page-loc
                              (:first-part :middle-part)
                              (inc (- total-pages min-last-part-buttons))

                              :last-part
                              (dec min-last-part))
            last-part (apply conj [:ellipsis]
                             (range last-part-start (inc total-pages)))]

        (flatten
          [:prev
           first-part
           middle-part
           last-part
           :next])))))

;; TODO: direct input of page number (validation ?)

(defn pagination-view
  "Show standard pagination view.

  on-change - callback that receives new page number
  current-page - current page selected
  per-page - number of items to shows per page
  max-buttons - max amount of buttons to show on the UI"
  [{:keys [on-change

           current-page
           total-count
           per-page
           max-buttons]}]
  (let [total-pages (int (/ total-count per-page))
        ;; Check for truncation
        total-pages (if (< (* total-pages per-page) total-count)
                      (inc total-pages)
                      total-pages)

        layout (build-pagination-buttons total-count per-page (or max-buttons 11) current-page)]
    [:nav
     (into
       [:ul.pagination.pagination-sm]
       (for [item layout]
         (cond
           (= :prev item)
           [:li.page-item
            [:a.page-link
             {:on-click (fn [e]
                          (when (and on-change
                                     current-page
                                     (> current-page 1))
                            (on-change (dec current-page))))}
             [icons/svg-arrow-left]]]

           (= :ellipsis item)
           [:li.page-item.disabled
            [:a.page-link
             "…"]]

           (int? item)
           ^{:key item}
           [:li.page-item
            {:class (dom/classes-pairs
                      :active (= item current-page))}
            [:a.page-link
             {:on-click (fn [e]
                          (when on-change
                            (on-change item)))}
             item]]

           (= :next item)
           [:li.page-item
            [:a.page-link
             {:on-click (fn [e]
                          (when (and on-change
                                     current-page
                                     (< current-page total-pages))
                            (on-change (inc current-page))))}
             [icons/svg-arrow-right]]])))]))


(defn get-page-indexes
  [total-count current-page per-page]
  [(* (dec current-page) per-page)
   (min (* current-page (* per-page))
        total-count)])

(defn get-current-page-items
  [items current-page per-page]
  (if (seq items)
    (apply subvec items (get-page-indexes (count items) current-page per-page))
    items))
